/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import { EvidencePart, ProgramSkill } from "@interfaces/Interfaces";
import { Text, View } from "@react-pdf/renderer";
import { getDisplayTitleForPDFExport } from "@utils/stringUtils";
import { updatePopoverTriggerWidth } from "@utils/popoverUtils";
import { IonRadio, IonItem, IonRadioGroup, IonSelect, IonList, IonSelectOption } from "@ionic/react";

type Props = {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  definition: EvidencePart;
  onValueChanged?: (value: any) => void;
  data?: any;
  isDisplay?: boolean;
  isPDF?: boolean;
  pdfStyles: any;
  initialValue?: any;
  skills: ProgramSkill[];
  preselectedSkill?: ProgramSkill | null;
};

const SkillsSelect: React.FC<Props> = (props) => {
  const [value, setValue] = useState<string>(props.initialValue ?? "");

  const valueChanged = (event: any): void => {
    const _value = event.detail.value;

    setValue(_value);
    props.onValueChanged && props.onValueChanged(_value);
  };

  useEffect(() => {
    if (props.preselectedSkill) {
      setValue(props.preselectedSkill.Name);
      props.onValueChanged && props.onValueChanged(props.preselectedSkill.Name);
    }
  }, [props.preselectedSkill?.ID]);

  if (props.isPDF) {
    return (
      <View>
        <Text style={props.pdfStyles.reflectionHeader}>{getDisplayTitleForPDFExport(props.definition)}</Text>
        <Text style={props.pdfStyles.evidenceDate}>{props.data}</Text>
      </View>
    );
  }

  if (props.isDisplay) {
    return (
      <div className="readEvidenceBlock">
        <div className="readEvidenceHeader">{props.definition["Display Title"] ?? props.definition.Name}</div>
        <div className="readEvidenceText">{props.data}</div>
        <div className="h-[1px] w-full bg-grey-30 mt-4" />
      </div>
    );
  }

  return (
    <div className="reflectionActivityTypeContainer">
      <IonList
        mode="md"
        className="reflectionActivityList w-full"
        color="white"
      >
        <IonItem
          mode="md"
          className="reflectionActivityItem"
          color="white"
        >
          <IonSelect
            color="white"
            mode="md"
            className="reflectionActivitySelectItem w-full"
            interface="popover"
            justify="space-between"
            interfaceOptions={{
              size: "cover",
              alignment: "start",
              cssClass: "evidence-select-popover",
            }}
            placeholder={props.definition["Placeholder Text"] || "Select skill"}
            value={value ?? undefined}
            onIonChange={valueChanged}
            onClick={updatePopoverTriggerWidth}
          >
            {props.skills.map((item) => {
              return (
                <IonSelectOption
                  color="white"
                  key={item.ID}
                  value={item.Name}
                >
                  {item.Name}
                </IonSelectOption>
              );
            })}
          </IonSelect>
        </IonItem>
      </IonList>
    </div>
  );

  return (
    <div>
      <IonRadioGroup
        color="light"
        id="editRoleRadioGroup"
        value={value}
        onIonChange={valueChanged}
      >
        {props.skills.map((item) => {
          return (
            <div key={item.ID}>
              <IonItem className="evidencePartsRadioContainer">
                <IonRadio
                  aria-label={item.Name}
                  mode="md"
                  value={item.Name}
                  justify="space-between"
                  className={`text-17px tracking-[-0.3] ${value === item.Name ? "font-semibold" : ""}`}
                >
                  {item.Name}
                </IonRadio>
              </IonItem>
            </div>
          );
        })}
      </IonRadioGroup>
    </div>
  );
};

export default SkillsSelect;
